import * as React from 'react';

import Form from '../../components/FormGenerator/Form';
import { Button, Section, Title, Loader } from '../../modules/modules';
import { MutationFunc } from 'react-apollo';
import FlashStore from '../../services/FlashStore';
import UserWrap from '../../components/UserWrap';
import { RouteComponentProps } from 'react-router-dom';

interface IGroupSectionProps {
  groupId: string;
  formPlaceholders?: any;
  data: any;
  updateUserInfo: MutationFunc;
}

interface IGroupSectionState {
  formValues: any;
  loaded: boolean;
}

class GroupSection extends React.Component<IGroupSectionProps & RouteComponentProps, IGroupSectionState> {
  public static getDerivedStateFromProps(props: IGroupSectionProps & RouteComponentProps, state: IGroupSectionState) {
    const groupId = (props.match.params as any).groupId;
    if (props.data.userInfo != undefined && !state.loaded && groupId) {
      const userInfo = props.data.userInfo as GQL.IUser;
      const values = userInfo.customerGroupsData && userInfo.customerGroupsData[groupId] || {};

      return {
        ...state,
        loaded: true,
        formValues: { ...values }
      };
    }

    return state;
  }

  constructor(props: IGroupSectionProps & RouteComponentProps) {
    super(props);
    this.state = {
      formValues: {},
      loaded: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  public getField(fields: any[], name: string) {
    const key = fields.findIndex((i: any) => i.fieldName === name);
    return fields[key];
  }

  public handleChange(value: any, field: string) {
    this.setState({ formValues: { ...this.state.formValues, [field]: value } });
  }

  public async handleSend(groupId: string) {    
    const { data } = this.props;
    if (!data) { 
      return;
    }
    const userInfo = data.userInfo as GQL.IUser;
    if (!userInfo) {
      return;
    }

    const newUserInfo = {
      ...userInfo,
      customerGroupsData: {
        ...(userInfo.customerGroupsData ? userInfo.customerGroupsData : {}),
        [groupId]: this.state.formValues,
      }
    };
    
    try {
      await this.props.updateUserInfo({
        variables: {
          user: {
            phone: newUserInfo.phone,
            
            invoiceFirstName: newUserInfo.invoiceFirstName,
            invoiceLastName: newUserInfo.invoiceLastName,
            invoiceStreet: newUserInfo.invoiceStreet,
            invoiceHouseNumber: newUserInfo.invoiceHouseNumber,
            invoiceAddressLine1: newUserInfo.invoiceAddressLine1,
            invoiceAddressLine2: newUserInfo.invoiceAddressLine2 || null,
            invoiceZip: newUserInfo.invoiceZip,
            invoiceCity: newUserInfo.invoiceCity,
            invoiceCountyState: newUserInfo.invoiceCountyState || null,
            invoiceCountry: newUserInfo.invoiceCountry,
            
            anotherDeliveryAddress: newUserInfo.anotherDeliveryAddress,
            deliveryStreet: newUserInfo.deliveryStreet ? newUserInfo.deliveryStreet : null,
            deliveryHouseNumber: newUserInfo.deliveryHouseNumber ? newUserInfo.deliveryHouseNumber : null,
            deliveryAddressLine1: newUserInfo.deliveryAddressLine1 ? newUserInfo.deliveryAddressLine1 : null,
            deliveryAddressLine2: newUserInfo.deliveryAddressLine2 ? newUserInfo.deliveryAddressLine2 || null : null,
            deliveryZip: newUserInfo.deliveryZip ? newUserInfo.deliveryZip : null,
            deliveryCity: newUserInfo.deliveryCity ? newUserInfo.deliveryCity : null,
            deliveryCountyState: newUserInfo.deliveryCountyState ? newUserInfo.deliveryCountyState || null : null,
            deliveryCountry: newUserInfo.deliveryCountry ? newUserInfo.deliveryCountry : null,
            
            receiveNewsletter: newUserInfo.receiveNewsletter || false,

            companyInformation: newUserInfo.companyInformation,
            companyName: newUserInfo.companyInformation ? newUserInfo.companyName : null,
            companyRegistrationNumber: newUserInfo.companyInformation ? newUserInfo.companyRegistrationNumber : null,
            companyVatNumber: newUserInfo.companyInformation ? newUserInfo.companyVatNumber : null,
            customerGroupsData: newUserInfo.customerGroupsData,
          }
        }
      });

      this.props.data.refetch();
      FlashStore.GetInstance().showMessage('Personal data successfully updated', 'success');
    } catch (e) {
      // TODO

    }
  }

  private renderGroupSection(groupId: string, userInfo: any) {
    const { customerGroups } = userInfo;
    const group = customerGroups && customerGroups.find((cg: any) => cg.id === groupId);

    const fields = group && group.fields && group.fields.split(/\n/).map((f: any) => {
      const d = f.split(';');
      const type = d.length === 3 ? 'select' : 'text';
      const options = (type === 'select' ? d[2].split(',') : []).map((v: any) => ({ value: v, label: v }));

      return {
        fieldName: d[0],
        label: d[0],
        placeholder: d[1],
        options,
        type,
    };
  }) || '';

    return (group && <div className="boundaries">
      <Title type="lower">{group.name}</Title>
      <div style={{ marginTop: 20, fontFamily: '"Corridor", sans-serif !important', fontWeight: 300 }}>{group.description}</div>
      <div className="form form--password">
        <Form
          fields={fields}
          values={this.state.formValues}
          handleChange={this.handleChange}
        >
          {(form: any) => {
            return (
              <Button
                type="red"
                onClick={() => {
                  this.handleSend(groupId);
                }}
              >
                Save changes
              </Button>
            );
          }}
        </Form>
      </div>
    </div>) || null;
  }

  public render() {
    const customer = this.props.data;
    const { groupId } = this.props.match.params as any;
    
    return (
      <main>
        <Section type="userPage">
          <UserWrap>

            {this.props.data.loading && 
              <Loader />}

            {customer.userInfo && this.renderGroupSection(groupId, customer.userInfo) || null}
          </UserWrap>
        </Section>
      </main>
    );
  }
}

export default GroupSection;



// WEBPACK FOOTER //
// ./src/pages/GroupSection/GroupSection.tsx